import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const accentClasses = {
    plasma: 'border-l-2 border-l-ax-plasma',
    aurora: 'border-l-2 border-l-ax-aurora',
    electric: 'border-l-2 border-l-ax-electric',
    critical: 'border-l-2 border-l-ax-critical',
};
export function Card({ accentLeft, interactive, className, children, ...rest }) {
    return (_jsx("div", { className: cn('bg-ax-graphite border border-ax-line rounded-ax-lg', 'transition-all duration-ax-fast ease-ax-base', accentLeft && accentClasses[accentLeft], interactive && 'cursor-pointer hover:bg-ax-night hover:border-[color:rgb(58_61_70)]', className), ...rest, children: children }));
}
export function CardHeader({ className, children, ...rest }) {
    return (_jsx("div", { className: cn('px-5 pt-5 pb-3 border-b border-ax-line', className), ...rest, children: children }));
}
export function CardBody({ className, children, ...rest }) {
    return (_jsx("div", { className: cn('px-5 py-4', className), ...rest, children: children }));
}
export function CardFooter({ className, children, ...rest }) {
    return (_jsx("div", { className: cn('px-5 pt-3 pb-5 border-t border-ax-line', className), ...rest, children: children }));
}
//# sourceMappingURL=Card.js.map